import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApple = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "2 1 19 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.6796 12.6745C15.691 11.791 15.9256 10.9247 16.3618 10.1563C16.7979 9.38788 17.4213 8.74224 18.174 8.27949C17.6959 7.59658 17.0651 7.03456 16.3317 6.63809C15.5983 6.24162 14.7826 6.02162 13.9493 5.99555C12.1718 5.80896 10.4486 7.05918 9.54281 7.05918C8.61949 7.05918 7.2249 6.01407 5.72314 6.04497C4.75176 6.07635 3.80508 6.35882 2.97533 6.86485C2.14558 7.37089 1.46106 8.08323 0.988467 8.93247C-1.05866 12.4768 0.468317 17.6859 2.42933 20.5509C3.41047 21.9538 4.55713 23.5209 6.05754 23.4653C7.52577 23.4044 8.07413 22.5291 9.8464 22.5291C11.6022 22.5291 12.1167 23.4653 13.6475 23.43C15.223 23.4044 16.2156 22.0208 17.1624 20.6046C17.8673 19.605 18.4098 18.5002 18.7697 17.3311C17.8543 16.944 17.0732 16.296 16.5237 15.4679C15.9742 14.6399 15.6806 13.6683 15.6796 12.6745Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.7881 4.1114C13.6471 3.08018 14.0703 1.75472 13.9678 0.416504C12.6555 0.554344 11.4432 1.18158 10.5726 2.17323C10.1469 2.65768 9.82087 3.22127 9.61314 3.8318C9.40541 4.44232 9.32004 5.0878 9.36192 5.73133C10.0183 5.73809 10.6678 5.59581 11.2612 5.31521C11.8547 5.03461 12.3768 4.62301 12.7881 4.1114V4.1114Z",
		fill: "black"
	})]
});
export default SvgApple;
